import {
  SQFT_APPLIANCES,
  WALL_MOUNTED_CABINET_BOX_PART_IDS,
  WALL_MOUNTED_CABINET_PARENT_PART_IDS,
} from "../constants";

// Checks every cabinet ancestry level because spacers keep their source part ids as parent/grandparent ids.
export const getIsShapePlacedOnTheWall = (shape) => {
  const cabinetPartIds = [
    shape.partId,
    shape.parentPartId,
    shape.grandParentPartId,
  ];

  return cabinetPartIds.some(partId => (
    WALL_MOUNTED_CABINET_BOX_PART_IDS.includes(partId)
    || WALL_MOUNTED_CABINET_PARENT_PART_IDS.includes(partId)
  )) || shape.subType === SQFT_APPLIANCES.hood;
};
